export default "__VITE_ASSET__BNd4jYC3__"